import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";

import request from "../../../../Helpers/API";

// Revierte el estatus de una visita ya realizada (solo rol URVR) — pide comentario del motivo.
// Conectado a VisitasCRM/RevertirEstatusVisita.
export const VisitasModalRevertir = ({ open, visita, onClose }) => {
  const [comentario, setComentario] = useState("");
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (open) setComentario("");
  }, [open]);

  if (!visita) return null;

  const handleGuardar = () => {
    if (!comentario.trim()) {
      Swal.fire("VISITAS", "Captura el motivo por el que se revierte el estatus", "warning");
      return;
    }

    const body = {
      id_visita: visita.id_visita,
      comentario,
    };

    setGuardando(true);
    request
      .post("VisitasCRM/RevertirEstatusVisita", body)
      .then(async () => {
        setGuardando(false);
        await Swal.fire("VISITAS", "Estatus revertido con éxito", "success");
        onClose(true);
      })
      .catch((error) => {
        setGuardando(false);
        Swal.fire("VISITAS", JSON.stringify(error), "error");
      });
  };

  return (
    <Modal open={open} onClose={() => onClose(false)}>
      <div className="crm-modal-card">
        <button type="button" className="crm-modal-cerrar" onClick={() => onClose(false)}>
          <CloseIcon fontSize="small" />
        </button>

        <h3 className="crm-modal-titulo">Revertir estatus · {visita.razon_social}</h3>

        <div className="crm-modal-body">
          <div className="crm-field">
            <label>Motivo por el que se revierte el estatus</label>
            <textarea
              className="crm-field-editable crm-modal-textarea"
              rows={4}
              placeholder="Explica por qué se revierte la visita de Realizada a Pendiente..."
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
            />
          </div>
        </div>

        <div className="crm-modal-buttons">
          <button type="button" className="btn-secundario-outline" onClick={() => onClose(false)}>Cancelar</button>
          <button type="button" className="btn-primario-solido" onClick={handleGuardar} disabled={guardando}>Revertir estatus</button>
        </div>
      </div>
    </Modal>
  );
};
